"use client"
import React, { useState, useEffect, useRef, useCallback } from "react"
import * as classes from "./technologies.module.scss"
import SlideWrapper from "@/components/Shared/SlideWrapper/slideWrapper"
// import Carousel from "nuka-carousel"
import { Carousel } from "nuka-carousel"
import { useBreakpoint } from "@/hooks/breakpoints"
import { Arrow } from "../../../../../public/icons/icon-components/arrow-forward"
// import React, { useRef } from "react";
// import { Carousel } from "nuka-carousel";
// Типы SlideHandle, CarouselProps, и т.д. тоже можно импортировать, если нужно.
// import { useBreakpoint } from "@/hooks/breakpoints";
import { cn } from "@/utils/cn"
import useEmblaCarousel from 'embla-carousel-react';
// Кастомный компонент со стрелками, пробрасываем коллбэки next/prev
function CustomArrows({ onPrev, onNext }) {
	return (
		<div
			style={{
				position: "absolute",
				top: "50%",
				width: "100%",
				display: "flex",
				justifyContent: "space-between",
				transform: "translateY(-50%)",
				pointerEvents: "none", // чтобы клики не ловились по фону
			}}
		>
			<button
				onClick={onPrev}
				style={{ pointerEvents: "auto", border: "none", background: "transparent" }}
			>
				<img
					src="/icons/arrow_down_icon.svg"
					alt="prev"
					style={{ transform: "rotate(90deg)" }}
				/>
			</button>
			<button
				onClick={onNext}
				style={{ pointerEvents: "auto", border: "none", background: "transparent" }}
			>
				<img
					src="/icons/arrow_down_icon.svg"
					alt="next"
					style={{ transform: "rotate(-90deg)" }}
				/>
			</button>
		</div>
	);
}

export function Technologies2({ data = [], theme }) {
	const breakpoint = useBreakpoint();
	const carouselRef = useRef(null);

	// Определяем сами, сколько хотим показывать
	let slidesToShow = 3; // desktop
	if (breakpoint.md) slidesToShow = 2;
	if (breakpoint.xs || breakpoint.sm) slidesToShow = 1;
	// Или любая ваша логика.

	// Коллбэки
	const handlePrev = () => {
		carouselRef.current?.goBack();
	};
	const handleNext = () => {
		carouselRef.current?.goForward();
	};

	return (
		<div style={{ fontFamily: theme?.fontFamilyPrimary }}>
			<h2 style={{ color: theme?.primaryTextColor }}>TECHNOLOGIES</h2>

			<div style={{ position: "relative" }}>
				<SlideWrapper triggerOnce direction="up" >
					<div className="flex gap-12 md:gap-8">
						<Carousel
							// нужные пропсы
							ref={carouselRef}
							wrapMode="nowrap"
							// при клике на стрелки или свайпе смещает ровно один "slide"
							scrollDistance="slide"
							// стрелки отключим, чтобы рендерить их самим через arrows={} или вообще вне
							showArrows={false}
							showDots={false}
						// Можно добавить автоплей, если надо
						// autoplay={true}
						// autoplayInterval={3000}
						// и т.д.
						// arrows={<CustomArrows ... />} // <- вариант, когда arrows внедряются в сам Carousel
						>
							{data.map((item, index) => (
								<div
									// Аналог .technologyPic:
									// margin-top: 20px => mt-5, размеры ~ w-[130px], h-[100px],
									// мобильные разрешения => можно адаптировать, напр. w-full, h-auto
									className="py-4 px-2"
								// className="m-0 p-1 w-[130px] h-[100px] sm:w-[140px] sm:h-[100px]"
								>
									<img
										src={item.logoImageUrl || "/icons/person.svg"}
										alt="profile pic"
										className="w-full 2xl:h-[80px] xl:h-[60px] h-[45px] object-contain"
									// className="w-full h-full object-contain"
									/>
								</div>
							))}
						</Carousel>
					</div>
				</SlideWrapper>

				{/* Ставим кастомные стрелки “поверх” карусели */}
				<CustomArrows onPrev={handlePrev} onNext={handleNext} />
			</div>
		</div>
	);
}

const Technologies = ({ data, theme }) => {
	const [emblaRef, emblaApi] = useEmblaCarousel({
		axis: 'x',

		dragFree: true,
		slidesToScroll: 2,
		skipSnaps: true,
		// containScroll: 'keepSnaps',
		containScroll: 'trimSnaps',
	});

	const [canPrev, setCanPrev] = useState(false);
	const [canNext, setCanNext] = useState(false);

	/* обновляем состояние стрелок при каждом выборе */
	const onSelect = useCallback(() => {
		if (!emblaApi) return;
		setCanPrev(emblaApi.canScrollPrev());
		setCanNext(emblaApi.canScrollNext());
	}, [emblaApi]);

	useEffect(() => {
		if (!emblaApi) return;
		onSelect();                     // инициализация
		emblaApi.on('select', onSelect);
		emblaApi.on('reInit', onSelect);
	}, [emblaApi, onSelect]);
	const showArrows = canPrev || canNext
	return (
		<div
		// className="flex w-full flex-col items-center justify-between"
		>
			<div className="pb-[30px] w-full ">
				{/* <div className="md:hidden pb-[30px] w-full "> */}
				<div
					className="py-2 xl:py-3 flex justify-between items-center min-w-full"
					style={{
						fontFamily: theme?.fontFamilyPrimary,
						color: theme?.primaryFontColor,
					}}
				>
					<p className="text-[24px] xl:text-[34px] font-medium leading-[100%]">
						Technologies:
					</p>



					{showArrows && (
						<div className="flex gap-4">
							<button
								disabled={!canPrev}
								onClick={() => emblaApi?.scrollPrev()}
								className="disabled:opacity-40 cursor-pointer disabled:cursor-default"
							>
								<Arrow color={theme.primaryFontColor} />
							</button>
							<button
								disabled={!canNext}
								onClick={() => emblaApi?.scrollNext()}
								className="disabled:opacity-40 cursor-pointer disabled:cursor-default"
							>
								<Arrow
									color={theme.primaryFontColor}
									style={{ transform: 'rotate(-180deg)' }}
								/>
							</button>
						</div>
					)}
				</div>
			</div>


			<div className={cn("overflow-hidden select-none min-w-full", showArrows ? 'block' : 'justify-center flex items-center ')} >
				{/* <div className="overflow-hidden xl:max-w-[90%]" ref={emblaRef}> */}
				<div className="cursor-grab " ref={emblaRef}>
					<div className="flex gap-4 ">
						{data.slice().map((item, index) => (
							// {data.slice(0, 3).map((item, index) => (
							<div
								key={index}
								className="flex select-none items-center justify-center mr-6 last:mr-0"
								// className="flex select-none items-center justify-center "
								style={{ flex: '0 0 auto' }}
							>
								<img
									src={item.logoImageUrl || '/icons/person.svg'}
									alt="technology"
									className="h-[45px] md:h-[52px] xl:h-[60px] object-contain"
								/>
							</div>
						))}
					</div>
				</div>
			</div>

		</div>
	)
}

export default Technologies
// const Technologies = ({ data, theme }) => {
// 	const [value, setValue] = useState(0)
// 	const [active, setActive] = useState(true)
// 	const breakpoint = useBreakpoint()
// 	const [slideToShow, setSlideToShow] = useState(6)
// 	const [cellAlign, setCellAlign] = useState("center")
// 	const carouselRef = useRef(null);

// 	const [currentIndex, setCurrentIndex] = useState(0);

// 	// Когда перелистали слайд, nuka вызовет afterSlide(endSlideIndex)
// 	const handleAfterSlide = (endSlideIndex) => {
// 		console.log('endSlideIndex', endSlideIndex)
// 		setCurrentIndex(endSlideIndex);
// 	};



// 	// Определяем, когда задизейблить или перекрасить кнопку
// 	const isAtFirstSlide = currentIndex <= 0;
// 	const isAtLastSlide = currentIndex >= data.length - 1;

// 	// Подбираем цвета
// 	const activeColor = theme?.primaryFontColor || "#000";
// 	const disabledColor = "blue"; // к примеру, серый
// 	const handlePrev = () => {
// 		console.log('prev')
// 		carouselRef.current?.goBack();
// 	};
// 	const handleNext = () => {
// 		console.log('next')
// 		carouselRef.current?.goForward();
// 	};
// 	useEffect(() => {
// 		if (breakpoint.sm || breakpoint.xs) {
// 			setSlideToShow(3)
// 			setCellAlign("left")
// 			data?.length > 3 ? setActive(true) : setActive(false)
// 		} else if (breakpoint.md) {
// 			setSlideToShow(4)
// 			setCellAlign("left")
// 			data?.length > 4 ? setActive(true) : setActive(false)
// 		} else if (breakpoint.lg) {
// 			setSlideToShow(5)
// 			setCellAlign("left")
// 			data?.length > 5 ? setActive(true) : setActive(false)
// 		} else if (breakpoint.xl) {
// 			setSlideToShow(4)
// 			setCellAlign("left")
// 			data?.length > 4 ? setActive(true) : setActive(false)
// 		} else {
// 			data?.length > 5 ? setActive(true) : setActive(false)
// 			setSlideToShow(5)
// 			setCellAlign("center")
// 		}
// 	}, [breakpoint, data])
// 	const [emblaRef, emblaApi] = useEmblaCarousel({
// 		axis: 'x',
// 		// loop: true,
// 		dragFree: true,
// 		slidesToScroll: 2,            
// 		containScroll: 'trimSnaps',
// 	});

// 	const [canPrev, setCanPrev] = useState(false);
// 	const [canNext, setCanNext] = useState(false);

// 	/* обновляем состояние стрелок при каждом выборе */
// 	const onSelect = useCallback(() => {
// 		if (!emblaApi) return;
// 		setCanPrev(emblaApi.canScrollPrev());
// 		setCanNext(emblaApi.canScrollNext());
// 	}, [emblaApi]);

// 	useEffect(() => {
// 		if (!emblaApi) return;
// 		onSelect();                     // инициализация
// 		emblaApi.on('select', onSelect);
// 		emblaApi.on('reInit', onSelect);
// 	}, [emblaApi, onSelect]);
// 	return (
// 		<div>
// 			<div
// 				className="flex w-full flex-col items-center justify-between"
// 			>
// 				<div className="pb-[30px] w-full ">
// 					{/* <div className="md:hidden pb-[30px] w-full "> */}
// 					<div
// 						className="py-2 xl:py-3 flex justify-between items-center min-w-full"
// 						style={{
// 							fontFamily: theme?.fontFamilyPrimary,
// 							color: theme?.primaryFontColor,
// 						}}
// 					>
// 						<p className="text-[24px] xl:text-[34px] font-medium leading-[100%]">
// 							Technologies:
// 						</p>



// 						{active && (
// 							<div className="flex gap-3">
// 								<button disabled={!canPrev} onClick={() => emblaApi?.scrollPrev()}
// 									className="disabled:opacity-40">
// 									<Arrow color={theme.primaryFontColor} />
// 								</button>
// 								<button disabled={!canNext} onClick={() => emblaApi?.scrollNext()}
// 									className="disabled:opacity-40">
// 									<Arrow color={theme.primaryFontColor} style={{ transform: 'rotate(-180deg)' }} />
// 								</button>
// 							</div>
// 						)}
// 					</div>
// 				</div>

// 				{/* <SlideWrapper triggerOnce direction="up" > */}
// 				<div className="overflow-hidden xl:max-w-[90%]" ref={emblaRef}>
// 					<div className="flex gap-4">
// 						{data.map((item, index) => (
// 							<div
// 								key={index}
// 								className="flex items-center justify-center mr-6 last:mr-0"
// 								style={{ flex: '0 0 auto' }}
// 							>
// 								<img
// 									src={item.logoImageUrl || '/icons/person.svg'}
// 									alt="technology"
// 									className="h-[45px] md:h-[52px] xl:h-[60px] object-contain"
// 								/>
// 							</div>
// 							// <div key={i} className="flex-none w-fit"
// 							// 	style={{ maxHeight: 45 }}> 
// 							// 	<img src={t.logoImageUrl || '/icons/person.svg'}
// 							// 		alt="tech" className="h-full w-auto object-contain" />
// 							// </div>
// 						))}
// 					</div>
// 				</div>
// 				{/* <div className="flex w-full max-w-fit">
// 					<Carousel
// 						ref={carouselRef}
// 						wrapMode="nowrap"
// 						// scrollDistance={120}
// 						scrollDistance={360}
// 						// scrollDistance="slide"
// 						// minSwipeDistance={300}
// 						afterSlide={handleAfterSlide}
// 						beforeSlide={(cur, end) => {
// 							console.log('cur', cur)
// 							console.log('end', end)
// 						}}
// 						// className="flex w-full max-w-fit"
// 						showArrows={false}
// 						showDots={false}
// 						// Важно: даём контейнеру фиксированную/относительную ширину,
// 						// чтобы "горизонтальная лента" могла скрываться и прокручиваться.
// 						style={{
// 							// width: "100%", // занимает всю доступную ширину
// 							overflow: "hidden", // скрываем горизонтальную полосу (управляем стрелками)
// 						}}
// 					>
// 						<>
// 							{[...data, ...data, ...data].map((item, index) => (
// 								<div
// 									key={index}
// 									className="flex items-center justify-center mr-6 last:mr-0"
// 									style={{ flex: '0 0 auto' }}
// 								>
// 									<img
// 										src={item.logoImageUrl || '/icons/person.svg'}
// 										alt="technology"
// 										className="h-[45px] object-contain"
// 									/>
// 								</div>
// 							))}
// 							<div className="items-center justify-center flex mr-6 bg-red-500" style={{
// 								flex: "0 0 auto",
// 							}} ><div clssName='size-[45px]' /></div>
// 							<div className="items-center justify-center flex mr-6 bg-red-500" style={{
// 								flex: "0 0 auto",
// 							}} ><div clssName='size-[45px]' /></div>
// 							<div className="items-center justify-center flex mr-6 bg-red-500" style={{
// 								flex: "0 0 auto",
// 							}} ><div clssName='size-[45px]' /></div>
// 							<div className="items-center justify-center flex mr-6 bg-red-500" style={{
// 								flex: "0 0 auto",
// 							}} ><div clssName='size-[45px]' /></div>
// 						</>
// 					</Carousel>
// 				</div> */}
// 				{/* </SlideWrapper> */}
// 				{/* <Carousel
// 					slidesToShow={slideToShow}
// 					slideIndex={value}
// 					className="md:hidden border border-red-800"
// 					// framePadding="0px 100px"
// 					renderBottomCenterControls={false}
// 					renderCenterLeftControls={false}
// 					renderCenterRightControls={false}
// 					cellSpacing={48}
// 					cellAlign={cellAlign}
// 				>
// 					<SlideWrapper triggerOnce direction="up" >
// 						<div className="flex gap-12 md:gap-8">
// 							{data.map((item, index) => (
// 								<div
// 									// Аналог .technologyPic:
// 									// margin-top: 20px => mt-5, размеры ~ w-[130px], h-[100px],
// 									// мобильные разрешения => можно адаптировать, напр. w-full, h-auto
// 									className="py-4 px-2"
// 								// className="m-0 p-1 w-[130px] h-[100px] sm:w-[140px] sm:h-[100px]"
// 								>
// 									<img
// 										src={item.logoImageUrl || "/icons/person.svg"}
// 										alt="profile pic"
// 										className="w-full 2xl:h-[80px] xl:h-[60px] md:h-[45px] object-contain"
// 									// className="w-full h-full object-contain"
// 									/>
// 								</div>
// 							))}
// 						</div>
// 					</SlideWrapper>
// 				</Carousel>
// 				<Carousel
// 					slidesToShow={slideToShow}
// 					slideIndex={value}
// 					className="hidden md:block"
// 					// framePadding="0px 100px"
// 					renderBottomCenterControls={false}
// 					renderCenterLeftControls={false}
// 					renderCenterRightControls={false}
// 					cellSpacing={48}
// 					cellAlign={cellAlign}
// 				>
// 					<SlideWrapper triggerOnce direction="up" >
// 						<div className="flex gap-12 md:gap-8">
// 							{data.map((item, index) => (
// 								<div
// 									// Аналог .technologyPic:
// 									// margin-top: 20px => mt-5, размеры ~ w-[130px], h-[100px],
// 									// мобильные разрешения => можно адаптировать, напр. w-full, h-auto
// 									className="py-4 px-2"
// 								// className="m-0 p-1 w-[130px] h-[100px] sm:w-[140px] sm:h-[100px]"
// 								>
// 									<img
// 										src={item.logoImageUrl || "/icons/person.svg"}
// 										alt="profile pic"
// 										className="w-full 2xl:h-[80px] xl:h-[60px] md:h-[45px] object-contain"
// 									// className="w-full h-full object-contain"
// 									/>
// 								</div>
// 							))}
// 						</div>
// 					</SlideWrapper>
// 				</Carousel> */}
// 			</div>
// 		</div>
// 	)
// }
// const Technologies = ({ data, theme }) => {
// 	const [value, setValue] = useState(0)
// 	const [active, setActive] = useState(true)
// 	const breakpoint = useBreakpoint()
// 	const [slideToShow, setSlideToShow] = useState(6)
// 	const [cellAlign, setCellAlign] = useState("center")
// 	const carouselRef = useRef(null);

// 	const [currentIndex, setCurrentIndex] = useState(0);

// 	// Когда перелистали слайд, nuka вызовет afterSlide(endSlideIndex)
// 	const handleAfterSlide = (endSlideIndex) => {
// 		console.log('endSlideIndex', endSlideIndex)
// 		setCurrentIndex(endSlideIndex);
// 	};



// 	// Определяем, когда задизейблить или перекрасить кнопку
// 	const isAtFirstSlide = currentIndex <= 0;
// 	const isAtLastSlide = currentIndex >= data.length - 1;

// 	// Подбираем цвета
// 	const activeColor = theme?.primaryFontColor || "#000";
// 	const disabledColor = "blue"; // к примеру, серый
// 	const handlePrev = () => {
// 		console.log('prev')
// 		carouselRef.current?.goBack();
// 	};
// 	const handleNext = () => {
// 		console.log('next')
// 		carouselRef.current?.goForward();
// 	};
// 	useEffect(() => {
// 		if (breakpoint.sm || breakpoint.xs) {
// 			setSlideToShow(3)
// 			setCellAlign("left")
// 			data?.length > 3 ? setActive(true) : setActive(false)
// 		} else if (breakpoint.md) {
// 			setSlideToShow(4)
// 			setCellAlign("left")
// 			data?.length > 4 ? setActive(true) : setActive(false)
// 		} else if (breakpoint.lg) {
// 			setSlideToShow(5)
// 			setCellAlign("left")
// 			data?.length > 5 ? setActive(true) : setActive(false)
// 		} else if (breakpoint.xl) {
// 			setSlideToShow(4)
// 			setCellAlign("left")
// 			data?.length > 4 ? setActive(true) : setActive(false)
// 		} else {
// 			data?.length > 5 ? setActive(true) : setActive(false)
// 			setSlideToShow(5)
// 			setCellAlign("center")
// 		}
// 	}, [breakpoint, data])

// 	return (
// 		<div
// 		// Аналог .technologiesWrapper:
// 		// По умолчанию (mobile) => колонки (flex-col), крупнее — можно оставить flex-row, если нужно
// 		// className=" flex flex-col gap-5 justify-between w-full mx-auto"
// 		>
// 			<div
// 				className="flex w-full flex-col items-center justify-between"
// 			>
// 				<div className="md:hidden pb-[30px] w-full ">
// 					<div
// 						className="py-2 flex justify-between items-center min-w-full"
// 						style={{
// 							fontFamily: theme?.fontFamilyPrimary,
// 							color: theme?.primaryFontColor,
// 						}}
// 					>
// 						<p className="text-[24px]">
// 							Technologies:
// 						</p>



// 						{active && (
// 							<div className="flex gap-3">
// 								{/* Кнопка назад */}
// 								<button
// 									onClick={handlePrev}
// 									// disabled={isAtFirstSlide}
// 									style={{
// 										border: "none",
// 										background: "transparent",
// 										cursor: isAtFirstSlide ? "default" : "pointer",
// 									}}
// 								>
// 									<Arrow color={isAtFirstSlide ? disabledColor : activeColor} />
// 								</button>
// 								{/* Кнопка вперёд */}
// 								<button
// 									onClick={handleNext}
// 									// disabled={isAtLastSlide}
// 									style={{
// 										border: "none",
// 										background: "transparent",
// 										cursor: isAtLastSlide ? "default" : "pointer",
// 									}}
// 								>
// 									<Arrow
// 										color={isAtLastSlide ? disabledColor : activeColor}
// 										style={{ transform: "rotate(-180deg)" }}
// 									/>
// 								</button>
// 							</div>
// 						)}
// 					</div>
// 				</div>
// 				{/* <div
// 					className="text-xl md:text-3xl font-medium"
// 					style={{
// 						fontFamily: theme?.fontFamilyPrimary,
// 						color: theme?.primaryFontColor,
// 					}}
// 				>
// 					Technologies:



// 					{active && (
// 						<div
// 							className="flex items-center gap-4"
// 						>
// 							<button
// 								onClick={() =>
// 									setValue((prev) => (prev <= 0 ? data?.length - 1 : prev - 1))
// 								}
// 								className="bg-transparent border-none cursor-pointer"
// 							>
// 								<Arrow color={theme.primaryFontColor} />
// 							</button>
// 							<button
// 								onClick={() =>
// 									setValue((prev) => (prev === data?.length - 1 ? 0 : prev + 1))
// 								}
// 								className="bg-transparent border-none cursor-pointer"
// 							>
// 								<Arrow
// 									color={theme.primaryFontColor}
// 									style={{ transform: "rotate(-180deg)" }}
// 								/>
// 							</button>
// 						</div>
// 					)}
// 				</div> */}

// 				{/* Сам слайдер */}

// 				{/* <SlideWrapper triggerOnce direction="up" > */}
// 				<div  className="flex w-full max-w-fit">
// 				<Carousel
// 					ref={carouselRef}
// 					wrapMode="nowrap"
// 					// scrollDistance={120}
// 					scrollDistance={360}
// 					// scrollDistance="slide"
// 					// minSwipeDistance={300}
// 					afterSlide={handleAfterSlide}
// 					beforeSlide={(cur, end) => {
// 						console.log('cur', cur)
// 						console.log('end', end)
// 					}}
// 					// className="flex w-full max-w-fit"
// 					showArrows={false}
// 					showDots={false}
// 					// Важно: даём контейнеру фиксированную/относительную ширину,
// 					// чтобы "горизонтальная лента" могла скрываться и прокручиваться.
// 					style={{
// 						// width: "100%", // занимает всю доступную ширину
// 						overflow: "hidden", // скрываем горизонтальную полосу (управляем стрелками)
// 					}}
// 				>
// 					<>
// 						{[...data, ...data, ...data].map((item, index) => (
// 							<div
// 								key={index}
// 								className="flex items-center justify-center mr-6 last:mr-0"
// 								style={{ flex: '0 0 auto' }}
// 							>
// 								<img
// 									src={item.logoImageUrl || '/icons/person.svg'}
// 									alt="technology"
// 									className="h-[45px] object-contain"
// 								/>
// 							</div>
// 						))}
// 						<div className="items-center justify-center flex mr-6 bg-red-500" style={{
// 							flex: "0 0 auto",
// 						}} ><div clssName='size-[45px]' /></div>
// 						<div className="items-center justify-center flex mr-6 bg-red-500" style={{
// 							flex: "0 0 auto",
// 						}} ><div clssName='size-[45px]' /></div>
// 						<div className="items-center justify-center flex mr-6 bg-red-500" style={{
// 							flex: "0 0 auto",
// 						}} ><div clssName='size-[45px]' /></div>
// 						<div className="items-center justify-center flex mr-6 bg-red-500" style={{
// 							flex: "0 0 auto",
// 						}} ><div clssName='size-[45px]' /></div>
// 					</>
// 				</Carousel>
// 				</div>
// 				{/* </SlideWrapper> */}
// 				{/* <Carousel
// 					slidesToShow={slideToShow}
// 					slideIndex={value}
// 					className="md:hidden border border-red-800"
// 					// framePadding="0px 100px"
// 					renderBottomCenterControls={false}
// 					renderCenterLeftControls={false}
// 					renderCenterRightControls={false}
// 					cellSpacing={48}
// 					cellAlign={cellAlign}
// 				>
// 					<SlideWrapper triggerOnce direction="up" >
// 						<div className="flex gap-12 md:gap-8">
// 							{data.map((item, index) => (
// 								<div
// 									// Аналог .technologyPic:
// 									// margin-top: 20px => mt-5, размеры ~ w-[130px], h-[100px],
// 									// мобильные разрешения => можно адаптировать, напр. w-full, h-auto
// 									className="py-4 px-2"
// 								// className="m-0 p-1 w-[130px] h-[100px] sm:w-[140px] sm:h-[100px]"
// 								>
// 									<img
// 										src={item.logoImageUrl || "/icons/person.svg"}
// 										alt="profile pic"
// 										className="w-full 2xl:h-[80px] xl:h-[60px] md:h-[45px] object-contain"
// 									// className="w-full h-full object-contain"
// 									/>
// 								</div>
// 							))}
// 						</div>
// 					</SlideWrapper>
// 				</Carousel>
// 				<Carousel
// 					slidesToShow={slideToShow}
// 					slideIndex={value}
// 					className="hidden md:block"
// 					// framePadding="0px 100px"
// 					renderBottomCenterControls={false}
// 					renderCenterLeftControls={false}
// 					renderCenterRightControls={false}
// 					cellSpacing={48}
// 					cellAlign={cellAlign}
// 				>
// 					<SlideWrapper triggerOnce direction="up" >
// 						<div className="flex gap-12 md:gap-8">
// 							{data.map((item, index) => (
// 								<div
// 									// Аналог .technologyPic:
// 									// margin-top: 20px => mt-5, размеры ~ w-[130px], h-[100px],
// 									// мобильные разрешения => можно адаптировать, напр. w-full, h-auto
// 									className="py-4 px-2"
// 								// className="m-0 p-1 w-[130px] h-[100px] sm:w-[140px] sm:h-[100px]"
// 								>
// 									<img
// 										src={item.logoImageUrl || "/icons/person.svg"}
// 										alt="profile pic"
// 										className="w-full 2xl:h-[80px] xl:h-[60px] md:h-[45px] object-contain"
// 									// className="w-full h-full object-contain"
// 									/>
// 								</div>
// 							))}
// 						</div>
// 					</SlideWrapper>
// 				</Carousel> */}
// 			</div>
// 		</div>
// 	)
// }
// const Technologies2 = ({ data, theme }) => {
// 	const [value, setValue] = useState(0)
// 	const [active, setActive] = useState(true)
// 	const breakpoint = useBreakpoint()
// 	const [slideToShow, setSlideToShow] = useState(6)
// 	const [cellAlign, setCellAlign] = useState("center")

// 	// Логика определения кол-ва слайдов (slideToShow) и выравнивания (cellAlign)
// 	// остаётся прежней. Только проверяйте правильность breakpoints (xs, sm, md, ...)
// 	// т.к. ваши условия должны совпадать с вашими useBreakpoint() значениями.
// 	useEffect(() => {
// 		if (breakpoint.sm || breakpoint.xs) {
// 			setSlideToShow(3)
// 			setCellAlign("left")
// 			data?.length > 3 ? setActive(true) : setActive(false)
// 		} else if (breakpoint.md) {
// 			setSlideToShow(4)
// 			setCellAlign("left")
// 			data?.length > 4 ? setActive(true) : setActive(false)
// 		} else if (breakpoint.lg) {
// 			setSlideToShow(5)
// 			setCellAlign("left")
// 			data?.length > 5 ? setActive(true) : setActive(false)
// 		} else if (breakpoint.xl) {
// 			setSlideToShow(4)
// 			setCellAlign("left")
// 			data?.length > 4 ? setActive(true) : setActive(false)
// 		} else {
// 			data?.length > 5 ? setActive(true) : setActive(false)
// 			setSlideToShow(5)
// 			setCellAlign("center")
// 		}
// 	}, [breakpoint, data])

// 	return (
// 		<div
// 		// Аналог .technologiesWrapper:
// 		// По умолчанию (mobile) => колонки (flex-col), крупнее — можно оставить flex-row, если нужно
// 		// className=" flex flex-col gap-5 justify-between w-full mx-auto"
// 		>
// 			<div
// 				className="flex w-full flex-col items-center justify-between"
// 			>
// 				<div className="md:hidden pb-[30px] w-full">
// 					<div
// 						className="py-2 flex justify-between items-center min-w-full"
// 						style={{
// 							fontFamily: theme?.fontFamilyPrimary,
// 							color: theme?.primaryFontColor,
// 						}}
// 					>
// 						<p className="text-[24px]">
// 							Technologies:
// 						</p>



// 						{active && (
// 							<div
// 								className="flex items-center gap-4 h-0"
// 							>
// 								<button
// 									onClick={() =>
// 										setValue((prev) => (prev <= 0 ? data?.length - 1 : prev - 1))
// 									}
// 									className="bg-transparent border-none cursor-pointer"
// 								>
// 									<Arrow color={theme.primaryFontColor} />
// 								</button>
// 								<button
// 									onClick={() =>
// 										setValue((prev) => (prev === data?.length - 1 ? 0 : prev + 1))
// 									}
// 									className="bg-transparent border-none cursor-pointer"
// 								>
// 									<Arrow
// 										color={theme.primaryFontColor}
// 										style={{ transform: "rotate(-180deg)" }}
// 									/>
// 								</button>
// 							</div>
// 						)}
// 					</div>
// 				</div>
// 				{/* <div
// 					className="text-xl md:text-3xl font-medium"
// 					style={{
// 						fontFamily: theme?.fontFamilyPrimary,
// 						color: theme?.primaryFontColor,
// 					}}
// 				>
// 					Technologies:



// 					{active && (
// 						<div
// 							className="flex items-center gap-4"
// 						>
// 							<button
// 								onClick={() =>
// 									setValue((prev) => (prev <= 0 ? data?.length - 1 : prev - 1))
// 								}
// 								className="bg-transparent border-none cursor-pointer"
// 							>
// 								<Arrow color={theme.primaryFontColor} />
// 							</button>
// 							<button
// 								onClick={() =>
// 									setValue((prev) => (prev === data?.length - 1 ? 0 : prev + 1))
// 								}
// 								className="bg-transparent border-none cursor-pointer"
// 							>
// 								<Arrow
// 									color={theme.primaryFontColor}
// 									style={{ transform: "rotate(-180deg)" }}
// 								/>
// 							</button>
// 						</div>
// 					)}
// 				</div> */}

// 				{/* Сам слайдер */}
// 				<Carousel
// 					slidesToShow={slideToShow}
// 					slideIndex={value}
// 					className="md:hidden border border-red-800"
// 					// framePadding="0px 100px"
// 					renderBottomCenterControls={false}
// 					renderCenterLeftControls={false}
// 					renderCenterRightControls={false}
// 					cellSpacing={48}
// 					cellAlign={cellAlign}
// 				>
// 					<SlideWrapper triggerOnce direction="up" >
// 						<div className="flex gap-12 md:gap-8">
// 							{data.map((item, index) => (
// 								<div
// 									// Аналог .technologyPic:
// 									// margin-top: 20px => mt-5, размеры ~ w-[130px], h-[100px],
// 									// мобильные разрешения => можно адаптировать, напр. w-full, h-auto
// 									className="py-4 px-2"
// 								// className="m-0 p-1 w-[130px] h-[100px] sm:w-[140px] sm:h-[100px]"
// 								>
// 									<img
// 										src={item.logoImageUrl || "/icons/person.svg"}
// 										alt="profile pic"
// 										className="w-full 2xl:h-[80px] xl:h-[60px] md:h-[45px] object-contain"
// 									// className="w-full h-full object-contain"
// 									/>
// 								</div>
// 							))}
// 						</div>
// 					</SlideWrapper>
// 				</Carousel>
// 				<Carousel
// 					slidesToShow={slideToShow}
// 					slideIndex={value}
// 					className="hidden md:block"
// 					// framePadding="0px 100px"
// 					renderBottomCenterControls={false}
// 					renderCenterLeftControls={false}
// 					renderCenterRightControls={false}
// 					cellSpacing={48}
// 					cellAlign={cellAlign}
// 				>
// 					<SlideWrapper triggerOnce direction="up" >
// 						<div className="flex gap-12 md:gap-8">
// 							{data.map((item, index) => (
// 								<div
// 									// Аналог .technologyPic:
// 									// margin-top: 20px => mt-5, размеры ~ w-[130px], h-[100px],
// 									// мобильные разрешения => можно адаптировать, напр. w-full, h-auto
// 									className="py-4 px-2"
// 								// className="m-0 p-1 w-[130px] h-[100px] sm:w-[140px] sm:h-[100px]"
// 								>
// 									<img
// 										src={item.logoImageUrl || "/icons/person.svg"}
// 										alt="profile pic"
// 										className="w-full 2xl:h-[80px] xl:h-[60px] md:h-[45px] object-contain"
// 									// className="w-full h-full object-contain"
// 									/>
// 								</div>
// 							))}
// 						</div>
// 					</SlideWrapper>
// 				</Carousel>
// 			</div>
// 		</div>
// 	)
// }

// const Technologies2 = ({ data, theme }) => {
// 	const [value, setValue] = useState(0)
// 	const [active, setActive] = useState(true)
// 	const breakpoint = useBreakpoint()
// 	const [slideToShow, setSlideToShow] = useState(6)
// 	const [cellAlign, setCellAlign] = useState("center")

// 	useEffect(() => {
// 		if (breakpoint.sm || breakpoint.xs) {
// 			setSlideToShow(3)
// 			setCellAlign("left")
// 			data?.length > 3 ? setActive(true) : setActive(false)
// 		} else if (breakpoint.md) {
// 			setSlideToShow(4)
// 			setCellAlign("left")
// 			data?.length > 4 ? setActive(true) : setActive(false)
// 		} else if (breakpoint.l) {
// 			setSlideToShow(5)
// 			setCellAlign("left")
// 			data?.length > 5 ? setActive(true) : setActive(false)
// 		} else if (breakpoint.xl) {
// 			setSlideToShow(4)
// 			setCellAlign("left")
// 			data?.length > 4 ? setActive(true) : setActive(false)
// 		} else {
// 			data?.length > 5 ? setActive(true) : setActive(false)
// 			setSlideToShow(5)
// 			setCellAlign("center")
// 		}
// 	}, [breakpoint, slideToShow])

// 	return (
// 		<div className={classes["technologiesWrapper"]}>
// 			<div className={classes["technologiesInnerWrapper"]}>
// 				<div
// 					className={classes["title"]}
// 					style={{
// 						fontFamily: theme?.fontFamilyPrimary,
// 						color: theme?.primaryFontColor,
// 					}}
// 				>
// 					Technologies:
// 				</div>
// 				{active && (
// 					<div className={classes["arrowIcons"]}>
// 						<button
// 							onClick={() =>
// 								setValue(prev => (prev <= 0 ? data?.length - 1 : prev - 1))
// 							}
// 							style={{
// 								border: "none",
// 								background: "transparent",
// 								cursor: "pointer",
// 							}}
// 						>
// 							<Arrow color={theme.primaryFontColor} />
// 						</button>
// 						<button
// 							onClick={() =>
// 								setValue(prev => (prev === data?.length - 1 ? 0 : prev + 1))
// 							}
// 							style={{
// 								border: "none",
// 								background: "transparent",
// 								cursor: "pointer",
// 							}}
// 						>
// 							<Arrow
// 								color={theme.primaryFontColor}
// 								style={{
// 									transform: "rotate(-180deg)",
// 								}}
// 							/>
// 						</button>
// 					</div>
// 				)}
// 			</div>
// 			<Carousel
// 				slidesToShow={slideToShow}
// 				slideIndex={value}
// 				framePadding="0px 100px "
// 				renderBottomCenterControls={false}
// 				renderCenterLeftControls={false}
// 				renderCenterRightControls={false}
// 				cellSpacing={48}
// 				cellAlign={cellAlign}
// 			>
// 				{data.map((item, index) => (
// 					<SlideWrapper triggerOnce direction={"up"} key={index}>
// 						<div className={classes["technologyPic"]}>
// 							{
// 								<img
// 									src={
// 										item.logoImageUrl ? item.logoImageUrl : "/icons/person.svg"
// 									}
// 									alt="profile pic"
// 									style={{ objectFit: 'contain' }}
// 								/>
// 							}
// 						</div>
// 					</SlideWrapper>
// 				))}
// 			</Carousel>
// 		</div>
// 	)
// }


